<template>
  <div class="shop">
    <div class="order_top">
      <div class="order_top_l">
        <span class="order_number">订单号:&nbsp;{{shoporderData.order_no}}</span>
        <p>下单用户:&nbsp;{{shoporderData.username}}</p>
        <p>
          订单类型:&nbsp;
          <strong v-if="shoporderData.order_type==1">爆款商品订单</strong>
          <strong v-if="shoporderData.order_type==5">现金券订单</strong>
          <strong v-if="shoporderData.order_type==10">拼团订单</strong>
          <strong v-if="shoporderData.order_type==15">会员专享订单</strong>
          <strong v-if="shoporderData.order_type==20">满减券订单</strong>
          <strong v-if="shoporderData.order_type==25">普通商品订单</strong>
        </p>
        <p v-if="shoporderData.remark">备注:&nbsp;{{shoporderData.remark}}</p>
        <p v-else>备注:&nbsp;无</p>
      </div>
      <div class="order_top_m">
        <p>创建时间:&nbsp;{{shoporderData.created_at}}</p>
        <p v-if="shoporderData.verify_time">核销时间:&nbsp;{{shoporderData.verify_time}}</p>
        <p v-else>
          核销时间:&nbsp;
          <strong>---</strong>
        </p>
      </div>
      <div class="order_top_r">
        <div class="order_status">
          <p>状态</p>
          <strong v-if="shoporderData.order_status==1">待支付</strong>
          <strong v-if="shoporderData.order_status==5">已支付</strong>
          <strong v-if="shoporderData.order_status==10">已核销</strong>
          <strong v-if="shoporderData.order_status==15">已取消</strong>
          <strong v-if="shoporderData.order_status==20">已失效</strong>
        </div>
        <div class="order_amount">
          <p>订单金额</p>
          <strong>{{shoporderData.total_amount}}</strong>
        </div>
        <div class="order_amount">
          <p>返红包数</p>
          <strong>{{shoporderData.rebate_money_yuan}}</strong>
        </div>
      </div>
    </div>
    <div class="order_line"></div>

    <div class="order_info">
      <span>商品信息:</span>
      <el-table :data="tableData"
        style="width:100%"
        max-height="600"
        :cell-style="tc"
        :header-cell-style="tccolor">
        <el-table-column prop="order_no"
          label="商品编号"></el-table-column>
        <el-table-column prop="title"
          label="商品名称"></el-table-column>
        <el-table-column prop="shop_name"
          label="所属小店"></el-table-column>
        <el-table-column prop="price"
          label="单价"></el-table-column>
        <el-table-column prop="quantity"
          label="数量(件)"></el-table-column>
        <el-table-column prop="actual_amount"
          label="金额"></el-table-column>
      </el-table>

      <!-- <div class="order_total">
            <p>总计</p>
            <p class="total">{{total}}</p>
      </div>-->
    </div>
  </div>
</template>

<script>
// import {mapState} from 'vuex'
import { orderProductDetailData } from "@/api/managent";
export default {

  data () {
    return {
      tableData: [],
      orderId: '',
      shoporderData: {}
    };
  },
  computed: {

    // ...mapState({
    //     shoporderData: state => state.shoporderData
    // })

  },
  mounted () {
    this.orderId = this.$route.query.order_no
    if (this.orderId) {
      this.getorderProductDetailData()
    }
  },
  methods: {
    async getorderProductDetailData () {
      let res = await orderProductDetailData(this.orderId)
      console.log(res)
      this.shoporderData = res.data
      this.tableData.push({ order_no: res.data.order_no, title: res.data.title, shop_name: res.data.shop_name, price: res.data.price, quantity: res.data.quantity, actual_amount: res.data.actual_amount })

    },
    tc () {
      return "text-align:center; color:#333333; font-size:12px;";
    },
    tccolor () {
      return "text-align:center;background-color:#f5f5f5; font-size:14px;";
    },
  }
};
</script>

<style lang="scss" scoped>
.shop {
  padding: 20px;
  position: absolute;
  width: 100%;
  .order_top {
    display: flex;
    flex-direction: row;

    p {
      margin-bottom: 20px;
    }

    strong {
      color: #f4222d;
      font-weight: 400;
    }
    .order_top_l {
      padding: 20px;
      height: 200px;
      flex: 1;
      .order_number {
        font-weight: 700;
        font-size: 21px;
        line-height: 21px;
        width: 300px;
        display: block;
        margin-bottom: 30px;
      }
    }
    .order_top_m {
      flex: 3;
      height: 200px;
      padding: 70px 0;
    }
    .order_top_r {
      height: 200px;
      flex: 1;
      display: flex;
      flex-direction: row;
      p {
        color: #999999;
        margin-bottom: 10px;
      }
      strong {
        font-size: 21px;
        color: #333333;
      }
      .order_status {
        flex: 1;
        padding: 70px 0;
      }
      .order_amount {
        flex: 1;
        padding: 70px 0;
      }
    }
  }

  .order_line {
    margin: 10px 0;
    color: #a8a8a8;
    height: 1px;
  }

  .order_info {
    padding: 0 20px;
    span {
      display: block;
      font-size: 21px;
      font-weight: 700;
    }
  }

  // .order_total{
  //     p{
  //         text-align: center;
  //         line-height: 50px;
  //         display: block;
  //          width: 180px;
  //          float: left;
  //     }
  //     .total{
  //         float: right;
  //         font-weight: 700;
  //     }
  // }
}
</style>